import { configureStore } from '@reduxjs/toolkit';
import AuthReducer from './reducer/authReducer';
import MarketingReducer from './reducer/marketingReducer';

export default configureStore({
  reducer: {
    auth: AuthReducer,
    marketing: MarketingReducer,
  },
})